import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ContentLoaderModule } from '@ngneat/content-loader';

@Component({
  selector: 'pr-list-skeleton',
  templateUrl: './list-skeleton.component.html',
  styleUrls: ['./list-skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ContentLoaderModule],
})
export class ListSkeletonComponent {}
